import React from "react";
import { Button } from "./button";
import { Typography } from "./index";
import { ArrowLeft } from "lucide-react";

interface NavigationHeaderProps {
  title: string;
  onBack: () => void;
  rightElement?: React.ReactNode;
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  title,
  onBack,
  rightElement,
}) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-3">
      <Button
        variant="ghost"
        size="sm"
        onClick={onBack}
        className="p-2 border border-gray-200 rounded-full hover:bg-gray-50"
      >
        <ArrowLeft className="h-5 w-5 text-gray-400" />
      </Button>
      <Typography
        variant="h1"
        className="text-sm md:text-lg font-semibold text-text-secondary"
      >
        {title}
      </Typography>
    </div>
    {rightElement}
  </div>
);

export default NavigationHeader;
